/**
 * Created by amirb on 12/30/14.
 * WidgetStateBase should handle all widget state (error,partial,fetching,success)
 */
define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var WidgetViewController = require('web-agent-framework/WidgetViewController');
    var SearchInputViewController = require('web-agent-viewControllers/SearchInputViewController');


    var WidgetStateBase = WidgetViewController.extend({
        ControllerName: "WidgetStateBase",
        applicationType: "WidgetStateBase",


        LPViewMap: {
            widgetWrapper: ".lpview_widget_wrapper",
            contentPlaceholder: '.lpview_widget_content_placeholder',
            statePlaceholder: '.lpview_widget_state_placeholdr',
            refreshAction: ".lpview_refresh_action",
            errorMessage: ".lpview_error_message_text"
        },

        LPStateMap: {
            error: "error",
            partial: "partial",
            fetching: "fetching",
            success: "success"
        },


        initialize: function () {
            this.initView();
        },

        events: function () {
            if (!this.singleton && !this.unBindState) {
                this.bindModel({modelPath : this.getRootModelPath() + ".state", callback : this.dataStateChanged});
            }
        },

        render: function () {
        }
    });

//this function will update the error message and create the view according to the widget template
    WidgetStateBase.prototype.initView = function () {
        var widgetTemplate = require('web-agent-templates/LP_base_widget.html');
        // var widgetTemplate = lpUtils.loadResource('web-agent-templates/LP_base_widget.html');
        var errorMessage = this.configuration.textPrefix ? "{{" + this.configuration.textPrefix + "_errorMessage" + "}}" : "";
        var messageMessage = this.configuration.textPrefix ? "{{" + this.configuration.textPrefix + "_messageMessage" + "}}" : "";
        var errorInfoLink = this.configuration.textPrefix ? "{{" + this.configuration.textPrefix + "_errorInfoLink" + "}}" : "";
        var errorFallbackLink = this.configuration.textPrefix ? "{{" + this.configuration.textPrefix + "_errorFallbackLink" + "}}" : "";
        var errorFallbackTextBeforeLink = this.configuration.textPrefix ? "{{" + this.configuration.textPrefix + "_errorFallbackTextBeforeLink" + "}}" : "";
        var errorFallbackTextAfterLink = this.configuration.textPrefix ? "{{" + this.configuration.textPrefix + "_errorFallbackTextAfterLink" + "}}" : "";

        widgetTemplate = this.injectTextDefaults(widgetTemplate, {
            errorMessage: errorMessage,
            messageMessage: messageMessage,
            errorInfoLink: errorInfoLink,
            errorFallbackLink: errorFallbackLink,
            errorFallbackTextBeforeLink: errorFallbackTextBeforeLink,
            errorFallbackTextAfterLink: errorFallbackTextAfterLink
        });

        this.createView({template: widgetTemplate, wrapWithDiv: false});

        this.createView({templateFile : this.configuration.templateFile,target : this.LPViewMap.contentPlaceholder, wrapWithDiv : false});

        if (!this.configuration.updateDataCallback) {
            this.lpHide(this.LPViewMap.refreshAction, '.error_widget');
        }
    };

    WidgetStateBase.prototype.setErrorMessage = function (errMsg) {
        var errMsgElement = this.getFirstElement(this.LPViewMap.errorMessage);
        errMsgElement.innerHTML = errMsg;
    };

    WidgetStateBase.prototype.dataStateChanged = function (data) {
        if (data && data.newValue) {
            this.setState(data.newValue);
        }
    };

    WidgetStateBase.prototype.setState = function (state) {
        this.logger.info('setting widget state to: ' + state, 'setState');
        var stateClasses = ["loading", "error", "partial", "success"];
        var stateIndex = stateClasses.indexOf(state);
        if (stateIndex >= 0) {
            stateClasses.splice(stateIndex, 1);
        }
        //***Because we have multi-instances of this element in the DOM, it's crucial that we fetch the element prior to the add/remove function
        var widgetWrapper = this.getFirstElement(this.LPViewMap.widgetWrapper); // TODO: Find out wtf is this and remove it. this is coupled with another controller.
        this.removeClass(widgetWrapper, stateClasses);
        if (state === this.LPStateMap.fetching) {
            state = 'loading';
        }

        this.addClass(widgetWrapper, state);
        if (state === this.LPStateMap.error && this.configuration.updateDataCallback) {
            this.bindViewEvent({selector: this.LPViewMap.refreshAction, DOMEvent: "click", callback: this.refreshClicked});
        }

        if (state === this.LPStateMap.error && this.handleErrorState) {
            this.handleErrorState();
        }
    };

    WidgetStateBase.prototype.refreshClicked = function () {
        this.unbindViewEvent({selector: this.LPViewMap.refreshAction, DOMEvent: "click", callback: this.refreshClicked});
        this.configuration.updateDataCallback.call(this);
    };

    WidgetStateBase.prototype.getRootModelPath = function () {
        return this.configuration.rootModelPath;
    };

    WidgetStateBase.prototype.bindEvents = function () {
        this.bindModel({modelPath : this.getRootModelPath() + ".state", callback : this.dataStateChanged});
    };

    WidgetStateBase.prototype.unbindEvents = function () {
        this.unbindModel({modelPath : this.getRootModelPath() + ".state", callback : this.dataStateChanged});
    };

    return WidgetStateBase;

});
